var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBdShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.503,
    height: 29.203,
    viewBox: "0 0 26.503 29.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-share-2",
    "data-name": "Icon feather-share-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M26.9,2.25A5.152,5.152,0,1,1,21.75,7.4,5.158,5.158,0,0,1,26.9,2.25Zm0,8.1A2.948,2.948,0,1,0,23.954,7.4,2.951,2.951,0,0,0,26.9,10.35Z",
    transform: "translate(-5.551 -2.25)",
    fill: "#40eefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M8.9,12.75A5.152,5.152,0,1,1,3.75,17.9,5.158,5.158,0,0,1,8.9,12.75Zm0,8.1A2.948,2.948,0,1,0,5.954,17.9,2.951,2.951,0,0,0,8.9,20.85Z",
    transform: "translate(-3.75 -3.3)",
    fill: "#40eefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M26.9,23.25A5.152,5.152,0,1,1,21.75,28.4,5.158,5.158,0,0,1,26.9,23.25Zm0,8.1A2.948,2.948,0,1,0,23.954,28.4,2.951,2.951,0,0,0,26.9,31.35Z",
    transform: "translate(-5.551 -4.351)",
    fill: "#40eefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M22.456,27.092a1.1,1.1,0,0,1-.554-.15l-9.22-5.373a1.1,1.1,0,0,1,1.11-1.9l9.22,5.373a1.1,1.1,0,0,1-.556,2.055Z",
    transform: "translate(-4.589 -3.977)",
    fill: "#40eefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M13.238,16.592a1.1,1.1,0,0,1-.557-2.054l9.207-5.373A1.1,1.1,0,0,1,23,11.069l-9.207,5.373A1.1,1.1,0,0,1,13.238,16.592Z",
    transform: "translate(-4.589 -2.927)",
    fill: "#40eefe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdShareIcon);
export default __webpack_public_path__ + "static/media/bd-share-icon.b76ab5cbd60e8932ab80811576560289.svg";
export { ForwardRef as ReactComponent };